import React from 'react';
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { dataFormStyles } from '~/modules/covenants/CovenantsDataForm/styles.ts';

interface ITableHeaderWithTooltipProps {
  label: string;
  tooltip?: string;
  ariaLabel?: string;
}

export const TableHeaderWithTooltip: React.FC<ITableHeaderWithTooltipProps> = ({
  label,
  tooltip,
  ariaLabel,
}) => {
  if (!tooltip) {
    return <>{label}</>;
  }

  return (
    <Box sx={dataFormStyles.headerInline}>
      <span>{label}</span>
      <Tooltip title={tooltip} arrow>
        <InfoOutlinedIcon
          sx={dataFormStyles.headerInfoIcon}
          aria-label={ariaLabel ?? `Column description for ${label}`}
        />
      </Tooltip>
    </Box>
  );
};
